export default __webpack_public_path__ + "static/articles-hepato-zasilvat-organ-19135692ced81bb0f2e14c081b697142.jpg";